import Vue from 'vue';
import { BfSpinner, BfButton } from "components/Butterfly";
import UserTypeSelect from 'src/components/account/UserList/UserTypeSelect.vue';
import Site from 'src/api/site';
import FormatUtils from 'src/utils/formatters';
import { arrayToTree } from 'src/utils/arrayToElTree';
export default Vue.extend({
    name: 'SiteUsersList',
    components: { BfSpinner, BfButton, UserTypeSelect },
    props: {
        currentUserId: { type: Number, default: undefined },
    },
    data() {
        return {
            loading: true,
            error: undefined,
            users: [],
            showDeleteModal: false,
            userToDelete: undefined,
            loadingDelete: false,
        };
    },
    mounted() {
        this.fetchUserData();
    },
    methods: {
        date(d) {
            return (d === null ? 'Never' : FormatUtils.date(d));
        },
        dashboardArrayToTree(dashboardData) {
            const tree = arrayToTree(dashboardData, 'analysis_id', 'analysis_name', 'project_id', 'project_name');
            return tree.map(project => {
                project.name = project.name + ' (Project)';
                project.children?.map(analysis => {
                    analysis.name = analysis.name + ' (Analysis)';
                    analysis.children?.map(dashboard => {
                        dashboard.name = dashboard.name + ' (Dashboard)';
                        return dashboard;
                    });
                    return analysis;
                });
                return project;
            });
        },
        async setPermission(new_type, acl) {
            const { id, user_type, email } = acl;
            await Site.setUserType(id, new_type);
            this.$analytics.track.site.userTypeChange(email, user_type, new_type);
            if (!this)
                return;
            this.$emit('user-changed');
            this.fetchUserData();
        },
        async setDisabled(acl, disabled) {
            const { id, email } = acl;
            await Site.setUserDisabled(id, disabled);
            this.$analytics.track.site.userAccountDisabled(email, disabled);
            if (!this)
                return;
            this.$emit('user-changed');
            this.fetchUserData();
        },
        async fetchUserData() {
            this.loading = true;
            try {
                const response = await this._fetch();
                if (!this)
                    return;
                this.users = response;
            }
            catch (e) {
                this.error = 'Unable to fetch user data';
            }
            finally {
                this.loading = false;
            }
        },
        _fetch() {
            return Site.getUserMembershipsV2();
        },
        deleteClearAndClose() {
            this.userToDelete = undefined;
            this.loadingDelete = false;
            this.showDeleteModal = false;
        },
        handleDeleteClicked(membershipId) {
            this.showDeleteModal = true;
            this.userToDelete = membershipId;
        },
        async deleteUser() {
            this.loadingDelete = true;
            if (!this.userToDelete)
                return;
            try {
                await Site.deleteUserMembership(this.userToDelete);
                this.deleteClearAndClose();
                this.$emit('user-changed');
                this.fetchUserData();
            }
            finally {
                this.loadingDelete = false;
            }
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            // We want to show the disabled state for every cell in the row except
            // the one with the menu to indicate that re-enabling the user is possible
            if (columnIndex === 5)
                return;
            return row.disabled ? { 'opacity': 0.45 } : {};
        },
    },
});
